<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'representativeform.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateRepresentativeForm"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'representativeform.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteRepresentativeForm"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['representativeForm'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteRepresentativeForm() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('representativeForm/delete', this.representativeForm.id);
          this.$store.dispatch('representativeForm/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateRepresentativeForm() {
        this.$router.push('/representative-processes/representative-forms/update/' + this.representativeForm.id);
      },
    }
  };
</script>
